import {
  GET_CATEGORY_PLANS,
  CREATE_CATEGORY_PLANS,
  DELETE_CATEGORY_PLANS,
  UPDATE_CATEGORY_PLANS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  RESET_CATEGORY_PLANS,
} from './actionType';

const INIT_STATE = {
  categoryPlans: null,
  error: {},
  success: '',
};

const CategoryPlans = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CATEGORY_PLANS:
          return {
            ...state,
            categoryPlans: action.payload.data,
            success: '',
            error: {},
          };
        case CREATE_CATEGORY_PLANS:
          return {
            ...state,
            success: 'Sucessfully created category plans',
            error: {},
          };
        case UPDATE_CATEGORY_PLANS:
          return {
            ...state,
            success: 'Sucessfully updated category plans',
            error: {},
          };
        case DELETE_CATEGORY_PLANS:
          return {
            ...state,
            success: 'Sucessfully delete category plans',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_CATEGORY_PLANS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_CATEGORY_PLANS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_CATEGORY_PLANS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_CATEGORY_PLANS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_CATEGORY_PLANS: {
      return {
        ...state,
      };
    }
    case CREATE_CATEGORY_PLANS: {
      return {
        ...state,
      };
    }
    case UPDATE_CATEGORY_PLANS: {
      return {
        ...state,
      };
    }
    case DELETE_CATEGORY_PLANS: {
      return {
        ...state,
      };
    }
    case RESET_CATEGORY_PLANS: {
      return {
        error: {},
        success: '',
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default CategoryPlans;
